export default __webpack_public_path__ + "static/media/Phones 1.9340238f.png";